//Rollbar - UI Logging
import Rollbar from 'rollbar';

export const rollbarConfig = {
  enabled: window._env_.ENV_TYPE !== 'local' && window._env_.ENABLE_LOGGING,
  accessToken: window._env_.ROLLBAR_ACCESS_TOKEN,
  environment: window._env_.ENV_TYPE,
  captureUncaught: true,
  captureUnhandledRejections: true,
  ignoredMessages: ['40[4,3] Failed', 'Request failed with status code 40[4,3]'],
  server: {
    root: window.location.hostname,
    branch: window._env_.ENV_TYPE,
  },
  code_version: window._env_.CODE_VERSION,
};

export const rollbarInstance = new Rollbar(rollbarConfig);
